<template>
  <div class="logos light" data-color="light">
    <div v-for="(row, rowIndex) in clients" :key="rowIndex" class="logos__container">
      <img
        v-for="(logo, logoIndex) in row.logos"
        :key="logoIndex"
        :src="logo.url"
        :alt="logo.title"
        :class="{ 'logo-visible': logoIndex === currentIndex }"
        :width="logo.logo_width"
        :height="logo.logo_height"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logos: { type: Array },
    duration: { type: Number },
  },
  data() {
    return {
      currentIndex: 0,
      clients: [],
    };
  },
  mounted() {
    this.clients = this.logos.map(row => ({
      logos: row.rows.map(item => ({
        ...item.logo,
        logo_width: item.logo_width,
        logo_height: item.logo_height,
      })),
    }));

    setInterval(this.incrementIndex, this.duration);
  },
  methods: {
    incrementIndex() {
      this.currentIndex = (this.currentIndex + 1) % this.clients[0].logos.length;
    },
  },
};
</script>

